import { useSearchParams } from "react-router-dom"

const usePagenation = (nowPage, maxPage, prefix = "") => {
    const [searchParams, setSearchParams] = useSearchParams()

    const getParamName = (paramName) => prefix ? `${prefix}_${paramName}` : paramName

    const prePageEvent = () => {
        if (nowPage > 1) {
            searchParams.set(getParamName("page"), parseInt(nowPage) - 1)
            setSearchParams(searchParams)
        }
    }

    const movePageEvent = (elem) => {
        searchParams.set(getParamName("page"), elem)
        setSearchParams(searchParams)
    }

    const nextPageEvent = () => {
        if (nowPage < maxPage) {
            searchParams.set(getParamName("page"), parseInt(nowPage) + 1)
            setSearchParams(searchParams)
        }
    }

    return [prePageEvent, movePageEvent, nextPageEvent]
}

export default usePagenation